'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */
/*
var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  /
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialise the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};
//const endlessCollection = new Ajaxinate({
//  container: '#CollectionLoop,#SearchLoop',
//  pagination: '.infinite_next',
//});
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
  document.addEventListener('DOMContentLoaded', function (){ 
    
    function cartUpdated() {
      var checkoutUrl = "/cart";
      var cart_total_price = $('.cart__total__price[data-cart-total]').data('cartTotal');
         
      if(cart_total_price >= window.offer_price_3 &&  window.offer_price_3 != undefined){          
        checkoutUrl = "/cart?discount=" + window.offer_code_3;
        console.log(checkoutUrl);
      }else if(cart_total_price >= window.offer_price_2){          
        checkoutUrl = "/cart?discount=" + window.offer_code_2;
        console.log(checkoutUrl);
      }else if(cart_total_price >= window.offer_price_1){         
        checkoutUrl = "/cart?discount=" + window.offer_code_1;
        console.log(checkoutUrl);
      }
      document.querySelector('#cartForm').setAttribute('action',checkoutUrl);
    }

    cartUpdated();
  
    // Target node (the div element)
    const targetNode = document.querySelector('[data-cart-price-holder]');
  
    // Options for the observer (what to observe)
    const config = { childList: true, subtree: true, characterData: true };
  
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          cartUpdated();
        }
      }
    };
  
    // Create a MutationObserver instance and start observing
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    document.querySelector('#gift_bag_item')?document.querySelector('#gift_bag_item').addEventListener('change', function(event){
      if(!event) return;
      let el = event.target;
      let gift_bag_id = el.value;
      if(el.checked){
        document.querySelector('.gift-bag-form [name="add"]').click();
      }else{
        document.querySelector('cart-drawer').querySelector('.cart__item[data-item-id="'+gift_bag_id+'"] .cart__item__remove')?.click();
      }
    }):null;
    
    var collectionSwatch = function() {
      $(document).on('click', '.custom_collection_swatches a.swatch', function(e) {
        e.preventDefault();
         $(this).parent().find('a.swatch').removeClass('selected-swatch');
         $(this).addClass('selected-swatch');
        var variantImg = $(this).data("image");
        var title = $(this).data('title');
        var variantId = $(this).attr('href').split('=')[1];
        $(this).parents('.product-item').find('.custom_option_title').html(title);
        if(variantId && variantId != '') $(this).parents('.product-item').find('.quick-add__holder input[name="id"]').val(variantId);
        
        if($(this).data("image").indexOf("no-image") == -1) {  
          $(this).parents('.product-item').find('.product-item__bg > figure.image-wrapper img').attr('src', variantImg);
          $(this).parents('.product-item').find('.product-item__bg > figure.image-wrapper img').attr('srcset', variantImg);
        } 
      }); 
    };
    var videoPlay = function() {
      $(document).on('click', '.videoPlay', function(e) {
        e.preventDefault();
        $(this).parent().addClass('active');
        if($(this).parent().find(".video_iframe_yt").length > 0){
          $(this).parent().find(".video_iframe_yt")[0].src += "&autoplay=1";
        }
        if($(this).parent().find("video").length > 0){
          $(this).parent().find(".ctm_video")[0].play();
        }
      });
      
      $(document).on('click', '.vid-play', function(e) {
        e.preventDefault();
         $(this).hide();
        $(this).parent().find('.vid-pause').css('display','block');
         $(this).parents('.videoWrapper').find("video").get(0).play();
      });
      $(document).on('click', '.vid-pause', function(e) {
        e.preventDefault();
        $(this).hide();
         $(this).parent().find('.vid-play').css('display','block');
         $(this).parents('.videoWrapper').find("video").get(0).pause();
      });
      
      $(document).on('click', '.vid-unmute', function(e) {
        e.preventDefault();
         $(this).hide();
        $(this).parent().find('.vid-mute').css('display','block');
         $(this).parents('.videoWrapper').find("video").prop('muted', false)
      });
      $(document).on('click', '.vid-mute', function(e) {
        e.preventDefault();
        $(this).hide();
         $(this).parent().find('.vid-unmute').css('display','block');
         $(this).parents('.videoWrapper').find("video").prop('muted', true)
      });
    };

    collectionSwatch();
    videoPlay(); 
    
    if(document.querySelector('#filter-Availability-1')?.checked){
      document.querySelector('.custom-inline-filter-wraper [for=filter-Availability-1]')?.setAttribute('checked','');
      document.querySelector('body').setAttribute('data-stock-item','');
    }else{
      document.querySelector('.custom-inline-filter-wraper [for=filter-Availability-1]')?.removeAttribute('checked');
      document.querySelector('body').removeAttribute('data-stock-item','');
    }
    document.querySelector('.collection__sidebar__slide-out')?.addEventListener('change',function(){
      if(document.querySelector('#filter-Availability-1')?.checked){
        document.querySelector('.custom-inline-filter-wraper [for=filter-Availability-1]')?.setAttribute('checked','');
        document.querySelector('body').setAttribute('data-stock-item','');
      }else{
        document.querySelector('.custom-inline-filter-wraper [for=filter-Availability-1]')?.removeAttribute('checked');
        document.querySelector('body').removeAttribute('data-stock-item','');
      }
    })

    $(".announcement_links--group").mouseenter(function(){
      $(".annoucement_submenu--group--wrapper").removeClass('active');
      $(this).find(".annoucement_submenu--group--wrapper").addClass('active');
    });
    $(".annoucement_submenu--group--wrapper").mouseleave(function(){
      $(this).removeClass('active');
    });
    $(".theme__header").mouseleave(function(){
      $('.annoucement_submenu--group--wrapper').removeClass('active');
    });
    $(".header__desktop__bar__c").mouseenter(function(){
      $('.annoucement_submenu--group--wrapper').removeClass('active');
    });   
    
  }, false);

(function() { 

  function removeCartItem(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId.toString(), // ensure it's a string
        quantity: 0
      })
    })
    .then(res => {
      if (!res.ok) throw new Error('HTTP error ' + res.status);
      return res.json();
    })
    .then(cart => {
      console.log('Removed variant', variantId);
      updateCart();
    })
    .catch(err => console.error('Remove failed:', err));
  }

  function formatShipByOrigin(d) {
    // Format like "Tue Sep 3"
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short', month: 'short', day: 'numeric'
    }).format(d);
  } 

  function computeFromEl(el) {
    const tz = 'America/Los_Angeles';
    const cutoffHour = parseInt('14', 10);    
    const isInStock = (el.querySelector('span').innerText.indexOf('Made to Order') < 0); 
    const now  = new Date();   
    const shipBy = new Date(el.querySelector('span').innerHTML.replace('\n','').split(':')[1].replace('Ships by ','') + ' ' + now.getFullYear());    
    return { shipBy, tz, isInStock };
  }

  function renderAll() {
    // Render line items
    document.querySelectorAll('.ships-by-message').forEach(el => {
      const { shipBy, tz, isInStock } = computeFromEl(el);      
      el.dataset.shipByIso = shipBy.toISOString(); // cache for summary
    });

    // Render cart summary (ship-together)
    const els = Array.from(document.querySelectorAll('.ships-by-message[data-ship-by-iso]'));
    const els2 = els.length ? els : Array.from(document.querySelectorAll('.ships-by-message'));
    let maxIso = null, tz = 'America/Los_Angeles';
    els2.forEach(el => {
      if (!el.dataset.shipByIso) { const c = computeFromEl(el); el.dataset.shipByIso = c.shipBy.toISOString(); tz = c.tz; }
      if (!maxIso || el.dataset.shipByIso > maxIso) maxIso = el.dataset.shipByIso;
      tz = tz;
    });
    const summary = document.getElementById('cart-ship-summary');
    if (summary && maxIso) {
      const d = new Date(maxIso);
      summary.textContent = 'Order ships together by ' + formatShipByOrigin(d) + '.';
      document.querySelector('#cart_promised_iso').value = maxIso;
    }    
  }

//  document.addEventListener('DOMContentLoaded', renderAll);
 // document.addEventListener('theme:cart:add', renderAll);
 // document.addEventListener('theme:cart:change', renderAll);  
 
  function getShipDates() {
    const items = Array.from(document.querySelectorAll('.ships-by-message'));
    const dates = items.map(el => {
      const c = computeFromEl(el);
      return { iso: c.shipBy.toISOString(), inStock: c.isInStock, tz: c.tz };
    });
    const tz = dates[0]?.tz || 'America/Los_Angeles';
    const inStockDates = dates.filter(d => d.inStock).map(d => d.iso).sort();
    const mtoDates     = dates.filter(d => !d.inStock).map(d => d.iso).sort();
    return {
      tz,
      maxOverall: dates.length ? new Date(dates.map(d=>d.iso).sort().slice(-1)[0]) : null,
      minInStock: inStockDates.length ? new Date(inStockDates[0]) : null,
      maxMTO:     mtoDates.length ? new Date(mtoDates.slice(-1)[0]) : null
    };
  }

  function renderSplitUI() {
    const box = document.getElementById('split-ship-checkbox');
    const note = document.getElementById('split-ship-note');
    const later_note = document.getElementById('split-ship-later-note');
    const main_note = document.getElementById('cart-ship-summary');
    if (!box || !note) return;

    const { tz, maxOverall, minInStock, maxMTO } = getShipDates();

    if (box.checked) {
      let text = '';
      let later_text = ''
      if (minInStock) text += 'In-stock items ship by ' + formatShipByOrigin(minInStock) + '. ';
      if (maxMTO)     later_text += 'Made-to-order items ship by ' + formatShipByOrigin(maxMTO) + '.';
      note.textContent = text;
      later_note.textContent = later_text;

      note.style.display = 'block';
      later_note.style.display = "block";
      main_note.textContent = "We’ll ship available items now and the rest later.";
      box.value = 'yes';
    } else {
      note.style.display = 'none';
      later_note.style.display = 'none';
      main_note.textContent = 'Order ships together by ' + formatShipByOrigin(maxOverall) + '.';
      box.value = 'no';
    }    
  }

  function splitFeeManage(){
    const box = document.getElementById('split-ship-checkbox');    
    box.addEventListener('change', function() {
      if(!event) return;
      const isChecked = this.checked;
      let el = event.target;
      let split_fee_id = el.getAttribute('data-value');
      
      if(el.checked){
        localStorage.split_fee = true;
        document.querySelector('.split-fee-form [name="add"]').click();        
      }else{
        localStorage.split_fee = false;
        document.querySelector('cart-drawer').querySelector('.cart__item[data-item-id="'+split_fee_id+'"] .cart__item__remove')?.click();        
      }
    });
  }

 // document.addEventListener('DOMContentLoaded', renderSplitUI);
 // document.addEventListener('theme:cart:add', renderSplitUI);
 // document.addEventListener('theme:cart:change', renderSplitUI);
  
 // document.addEventListener('DOMContentLoaded', splitFeeManage);
    
})();

